<template>
  <vgp-core-popup
    :show="showPopup"
    :width="'540'"
    :title="title"
  >
    <template #body>
      <div :class="$style.message_us_body">
        <template
          v-if="showStubThanks"
        >
          <svg-image
            name="feedback-stub-thanks"
            :class="$style.thanks_image"
          />
          <div
            :class="$style.thanks_description"
            v-html="locale('nps_thank_popup_title')">
          </div>
          <div :class="$style.buttons">
            <vgp-button
              type="primary"
              :label="locale('common_ok')"
              :small="true"
              @onClick="hidePopup" 
            />
          </div>

        </template>
        <template v-else>
          <div :class="$style.description">
            {{ description }}
          </div>
          <textarea
            ref="textarea"
            name="messageUsTextArea"
            :class="[
              $style.text_area,
              invalidFeedback && $style.invalid
            ]"
            :placeholder="textAreaPlaceholder"
            v-model="feedbackValue"
            required
          />
          <div :class="$style.buttons">
            <vgp-button
              type="secondary"
              :label="locale('common_cancel')"
              :small="true"
              @onClick="hidePopup" 
            />
            <vgp-button
              type="primary"
              :label="locale('common_send')"
              :small="true"
              :isLoading="isSendingFeedback"
              @onClick="sendFeedback" 
            />
          </div>
        </template>
        
      </div>
    </template>
  </vgp-core-popup>
</template>

<script>
import app from '$$app';
import routerHelper from '$$helpers/router';
import helperFeedback from '$$helpers/feedback';
import vgpButton from '$$vueCmp/globalButton/vgpButton.vue';
import svgImage from '$$vueCmp/VueIcon/vgpSvgImage.vue';

export default {
  components: {
    vgpButton,
    svgImage,
  },
  name: 'MessageUsPopup',
  data() {
    return {
      locale: __,
      showPopup: false,
      appListeners: [],
      description: __('message_us_popup_description'),
      title: '',
      planName: '',
      featuresName: '',
      textAreaPlaceholder: '',
      feedbackValue: '',
      invalidFeedback: false,
      failedSubmit: false,
      showStubThanks: false,
      isSendingFeedback: false,
    };
  },
  created() {
    this.appListeners.push(app.on('showFeedbackForm', this.showPopupListener));
  },
  beforeUnmount() {
    this.appListeners.forEach(id => app.off(id));
    this.appListeners = [];
  },
  watch: {
    feedbackValue(newValue) {
      this.invalidFeedback = this.failedSubmit && !newValue.trim();
    }
  },
  methods: {
    showPopupListener(featuresName, planName, additionalKey) {
      userExtAnalytics.log('pricing_contact_us_opened', planName);
      this.planName = planName;
      this.featuresName = featuresName;
      this.title = __(`message_header_title_${featuresName}`);
      this.textAreaPlaceholder = __(`message_view_placeholder_${additionalKey || featuresName}`);

      this.showPopup = true;
      this.focusTextArea();

      this.analyticsMessageUsForm(featuresName);
    },
    hidePopup() {
      this.showPopup = false;
      this.title = '';
      this.planName = '';
      this.featuresName = '';
      this.feedbackValue = '';
      this.textAreaPlaceholder = '';
      this.invalidFeedback = false;
      this.failedSubmit = false;
      this.showStubThanks = false;
      this.isSendingFeedback = false;
    },
    sendFeedback() {
      if (!this.feedbackValue.trim()) {
        this.invalidFeedback = true;
        this.failedSubmit = true;
        this.focusTextArea();
        return;
      }

      this.isSendingFeedback = true;
      this.sendEmail();
    },
    focusTextArea() {
      this.$nextTick(() => {
        this.$refs.textarea.focus();
      });
    },
    analyticsMessageUsForm(data) {
      const url = routerHelper.getCurrentRoute().fullPath;
      let from = '';

      if (url.includes('workload')) {
        from = 'general workload';
        if (url.includes('project/')) from = 'project workload';
        if (url.includes('projects/')) from = 'portfolio  workload';
      } else {
        if (url.includes('reports')) from = 'reports';
        if (url.includes('integrations')) from = 'integrations';
        if (url.includes('list') && url.includes('tasks')) from = 'mylist';
        if (url.includes('dashboard')) from = 'portfolio dashboard';
      }

      if (!from) return;
      userExtAnalytics.log('header_click_missed_features', { from });
    },
    sendEmail() {
      helperFeedback.send({
        message: this.feedbackValue,
        type: this.featuresName,
        send_followup_email: false,
      }).then(() => {
        userExtAnalytics.log('pricing_contact_us_sent', this.planName);
        this.title = '';
        this.isSendingFeedback = false;
        this.showStubThanks = true;
      }).catch(() => {
        this.hidePopup();
      });
    },
  }
}
</script>

<style module src="./messageUsPopup.less"></style>
